import React from 'react';

import { viewTypes }  from './view-types.js';
import CalendarHeader from './calendar-header.jsx';

class MonthView extends React.Component {
    touchStartLocation = { x: 0, y: 0 };

    constructor( props ) {
        super( props );

        this.state = {
            focus: false,
            focusRow: 0,
            focusCol: 0
        };
    }

    render() {
        const {
            year,
            ariaLabels
        } = this.props;

        const quartersAndMonth = this.getQuartersAndMonths();

        return (
            <div className="month-view" aria-label={ ariaLabels.title }
                onTouchStart={ this.handleTouchStart } onTouchMove={ this.handleTouchMove }>

                <CalendarHeader text={ year } onDrill={ this.handleDrill }
                    onPrevious={ this.handlePrev } previousText={ ariaLabels.prevYear }
                    onNext={ this.handleNext } nextText={ ariaLabels.nextYear } />

                <input autoFocus={ true } onFocus={ this.handleInputFocus } onBlur={ this.handleInputBlur } aria-hidden={ true }
                    onKeyDown={ this.handleInputKeyDown } style={ { position: 'absolute', opacity: '0', pointerEvents: 'none', zIndex: -1 } }/>
                {
                    quartersAndMonth.map( ( quarter, index ) => {
                        return <div key={ index } className="quarter">
                            {
                                quarter.map( ( month ) => {
                                    return <div key={ month.number } role="link" className={ 'month' +
                                            ( month.today ? ' today' : '' ) +
                                            ( month.selected ? ' selected' : '' ) +
                                            ( month.focus ? ' focus' : '' ) }
                                        onClick={ () => {
                                            this.selectMonth( month.number );
                                        } }>
                                            <span>{ month.text }</span>
                                            { month.hasActivity && <span className="activity" /> }
                                        </div>;
                                } )
                            }
                        </div>;
                    } )
                }
            </div>
        );
    }

    handleDrill = () => {
        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.year, this.props.year, this.props.month );
        }
    };

    handlePrev = () => {
        const {
            year,
            month
        } = this.props;

        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.month, year - 1, month );
        }
    };

    handleNext = () => {
        const {
            year,
            month
        } = this.props;

        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.month, year + 1, month );
        }
    };

    getQuartersAndMonths = () => {
        const quarters = [];

        const today = new Date();
        const todayYear = today.getFullYear();
        const todayMonth = today.getMonth();

        const selectedYear = ( this.props.value ? this.props.value.getFullYear() : null );
        const selectedMonth = ( this.props.value ? this.props.value.getMonth() : null );

        this.selectedRow = 0;
        this.selectedCol = 0;

        for ( let q = 0; q < 4; q++ ) {
            const quarter = [];
            quarters.push( quarter );

            for ( let m = ( q * 3 ); m < ( ( q + 1 ) * 3 ); m++ ) {
                 const date = new Date( this.props.year, m, 1, 0, 0, 0, 0 );

                 const lastDateInMonth = new Date( this.props.year, m, 1, 0, 0, 0, 0 );
                 lastDateInMonth.setMonth( lastDateInMonth.getMonth() + 1 );
                 lastDateInMonth.setMilliseconds( lastDateInMonth.getMilliseconds() - 1 );

                quarter.push( {
                    number: m,
                    text: this.getMonthText( date ).toUpperCase(),
                    today: ( this.props.year === todayYear && m === todayMonth ),
                    selected: ( this.props.year === selectedYear && m === selectedMonth ),
                    focus: ( this.state.focus && this.state.focusRow === q && this.state.focusCol === ( m % 3 ) ),
                    hasActivity: ( typeof this.props.hasActivity === 'function' && this.props.hasActivity( date, lastDateInMonth ) )
                } );

                if ( m === selectedMonth ||
                    ( !this.props.value && this.props.year === todayYear && m === todayMonth ) ) {
                    this.selectedRow = q;
                    this.selectedCol = ( m % 3 );
                }
            }
        }

        return quarters;
    };

    selectMonth = ( month ) => {
        const year = this.props.year;

        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.date, year, month );
        }
    };

    handleTouchStart = ( e ) => {
        this.touchStartLocation = { x: e.touches[ 0 ].clientX, y: e.touches[ 0 ].clientY };
    };

    handleTouchMove = ( e ) => {
        const xDiff = e.touches[ 0 ].clientX - this.touchStartLocation.x;
        const yDiff = e.touches[ 0 ].clientY - this.touchStartLocation.y;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
            if ( xDiff > 0 ) {
                this.handlePrev();
            } else {
                this.handleNext();
            }
        }
    };

    handleInputFocus = () => {
        this.setState( {
            focus: true,
            focusRow: this.selectedRow,
            focusCol: this.selectedCol
        } );
    };

    handleInputBlur = () => {
        this.setState( {
            focus: false
        } );
    };

    handleInputKeyDown = ( e ) => {
        let {
            focusRow,
            focusCol
        } = this.state;

        switch ( e.keyCode ) {
            case 38: //up arrow
                focusRow = focusRow - 1;
                if ( focusRow < 0 ) { focusRow = 3; }

                this.setState( { focusRow: focusRow } );
                break;
            case 40: //down arrow
                focusRow = focusRow + 1;
                if ( focusRow > 3 ) { focusRow = 0; }

                this.setState( { focusRow: focusRow } );
                break;
            case 37: //left arrow
                focusCol = focusCol - 1;
                if ( focusCol < 0 ) { focusCol = 2; }

                this.setState( { focusCol: focusCol } );
                break;
            case 39: //right arrow
                focusCol = focusCol + 1;
                if ( focusCol > 2 ) { focusCol = 0; }

                this.setState( { focusCol: focusCol } );
                break;
            case 13: //enter
                const month = ( ( focusRow * 3 ) + focusCol );

                this.selectMonth( month );
                break;
            default:
                break;
        }
    };

    getMonthText = ( date ) => {
        return new Intl.DateTimeFormat( this.props.locale, { month: 'short' } ).format( date );
    };
}

export default MonthView;
